const isCaseTerminated = (caseDetails) => {
  if (caseDetails.status === "Terminated") {
    return true;
  }
  return false;
};

export default isCaseTerminated;
